export default __webpack_public_path__ + "static/media/experience.b716344a.png";